/* eslint-disable import/prefer-default-export */
export const APIENDPOINT = 'https://scpc.prismic.io/api/v2';
export const URLROOT = 'https://www.scpcny.com';
export const TITLESUFFIX = 'Shen Chang, P.C.';
